export const LocalStorageKeys = {
    LOCAL_STORAGE_AUTH_USER_ID_KEY: 'literatour_xp_logged_user_id',
     LOCAL_STORAGE_AUTH_TOKEN_KEY : 'literatour_xp_logged_user_token',
    LOCAL_STORAGE_AUTH_TOKEN_EXPIRATION_DATE_KEY : 'literatour_xp_logged_user_expiration_date',
    LOCAL_STORAGE_AUTH_USER_NAME_KEY : 'literatour_xp_logged_user_name',
  
  }
  